import config from '../../config';
const { listingTypeHorse, listingTypeRider } = config;

const imagesMapper = {
    [listingTypeRider]: [
        'pferd-hinzufuegen',
        'pferdemenschen-finden',
        'nachrichten-senden-und-erhalten',
        'persoenliches-kennenlernen-mit-pferdemensch',
    ],
    [listingTypeHorse]: [
        'profil-erstellen',
        'pferde-finden',
        'anfragen-senden-und-erhalten',
        'persoenliches-kennenlernen-mit-pferdebesitzerin',
    ],
};

export default (type, intl) =>
    [0, 1, 2, 3].map(index => ({
        url: `url('https://horsedeal.imgix.net/static/landingPage/${imagesMapper[type][index]}.webp')`,
        heading: intl.formatMessage({
            id: `SectionHowItWorks.instructionHeading-${index}-${type}`,
        }),
        instruction: intl.formatMessage({
            id: `SectionHowItWorks.instructionDesc-${index}-${type}`,
        }),
    }));
